import React, { createContext, useState, useMemo } from 'react';
import { BANK_INFO } from './initialValues';
export var bankInfoContext = createContext(BANK_INFO);
var BankInfoProvider = function (props) {
    var _a = useState({}), bankInfoForm = _a[0], setBankInfoForm = _a[1];
    var contextValue = useMemo(function () { return ({
        bankInfoForm: bankInfoForm,
        setBankInfoForm: setBankInfoForm,
    }); }, [bankInfoForm]);
    return (React.createElement(bankInfoContext.Provider, { value: contextValue }, props.children));
};
export default BankInfoProvider;
